import Login from "./loginRoutes";

export default Login